var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "krasjet bil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73615 9.80931L18.1781 10.9562L15.851 6.88383L10.1828 8.18035L4.39835 4.92242L2.73615 9.80931ZM16.5158 15.2115C17.4467 15.2115 18.1781 14.4967 18.1781 13.5825C18.1781 12.6683 17.4467 11.9536 16.5158 11.9536C15.585 11.9536 14.8536 12.6683 14.8536 13.5825C14.8703 14.4967 15.585 15.2115 16.5158 15.2115ZM4.39835 15.2115C5.32919 15.2115 6.06056 14.4967 6.06056 13.5825C6.06056 12.6683 5.32919 11.9536 4.39835 11.9536C3.46752 11.9536 2.73615 12.6683 2.73615 13.5825C2.73615 14.4967 3.46752 15.2115 4.39835 15.2115ZM17.4633 6.30205L20.4054 12.0034V19.5665C20.4054 20.1815 19.94 20.6303 19.325 20.6303H18.1781C17.563 20.6303 17.0976 20.1649 17.0976 19.5665V18.4528H3.8332V19.5665C3.8332 20.1815 3.36779 20.6303 2.75277 20.6303H1.58922C0.974207 20.6303 0.508789 20.1649 0.508789 19.5665V10.8731L2.78601 4.35727C3.0021 3.69239 3.66698 3.29346 4.39835 3.29346L10.2659 6.56801L15.8676 5.23824C16.5823 5.23824 17.2638 5.65379 17.4633 6.30205Z",
    fill: "#016CC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7312 1.91373C10.8808 2.61186 10.1328 5.68694 10.1328 5.68694C10.1328 5.68694 8.27111 3.12714 8.12151 2.42901C7.97192 1.73089 8.45396 1.03276 9.1687 0.899783C9.88345 0.766806 10.5816 1.2156 10.7312 1.91373Z",
    fill: "#016CC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6598 4.29074C12.4936 4.5567 11.3467 5.33793 11.3467 5.33793C11.3467 5.33793 11.5129 3.97492 11.6625 3.69235C11.8287 3.4264 12.1778 3.32666 12.4604 3.49288C12.7429 3.65911 12.826 4.02479 12.6598 4.29074Z",
    fill: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrash);
export default __webpack_public_path__ + "static/media/crash.e99b0023.svg";
export { ForwardRef as ReactComponent };